import { EnvironmentProviders } from '@angular/core';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from '@app/core/interceptors/jwt.interceptor';
import { errorInterceptor } from '@app/core/interceptors/error.interceptor';
import { schemaInterceptor } from '@app/core/interceptors/schema.interceptor';

/** Run in this order on every request. */
export const httpInterceptors: HttpInterceptorFn[] = [schemaInterceptor, jwtInterceptor, errorInterceptor];

/**
 * HttpClient with the app's interceptors. Provide it once, in AppModule: a lazy module that provides its own
 * HttpClient would bypass these, and importing this file from a feature module creates an import cycle
 * (jwt.interceptor → AuthenticationService → … → CoreModule).
 */
export function provideAppHttpClient(): EnvironmentProviders {
	return provideHttpClient(withInterceptors(httpInterceptors));
}
